module.exports = __webpack_public_path__ + "img/memorial-day-donating.f40a17df.png";